module.exports = __webpack_public_path__ + "img/1.207cc3bc.jpg";